import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class SocketAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = "Management";
  controllerName = "socket";

  /**
   * Lấy token kết nối
   */
  getToken() {
    let request = {
      url: `${window._apis[this.apiName]}/${this.controllerName}/connect/token`,
    };

    return httpClient.getAsync(request);
  }
}

export default new SocketAPI();
